var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg130(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5V3H8V2H7V1H6V0H4v1H3v1H2v1H1v2H0v4h1v1h1v1h1v1h4v-1h1v-1h1V9h1V5z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V4H7V3H6V2H5V1H4v2H3v1H2v2H1v3h1v1h1v1h4v-1h1V9h1V6z",
    fill: "#ff6f00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6V4H6V3H5v1H4v1H3V4H2v6h1v1h4V9h1V6z",
    fill: "#fa0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6V5H4v1H3v2H2v2h1v1h3V9h1V7H6zM7 6h1v1H7zM6 4h1v1H6zM2 5h1v1H2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg130);
export default __webpack_public_path__ + "static/media/130.7695b9410dad6f28a98469c69e49d812.svg";
export { ForwardRef as ReactComponent };